export default "__VITE_ASSET__Dee2JiIw__"